import { css } from 'styled-components';
import {
  getSpacing, getTypography, TypographyName, SpacingName, BreakpointQueryName, ThemedFunctor, rgba,
} from '@doveit/lego';

export const basic: ThemedFunctor = ({ $isInteractive }) => css`
  position: relative;
  overflow: hidden;

  ${$isInteractive && `
    cursor: pointer;
  `}
`;

export const overlayLink = css`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2;
  display: block;
  cursor: pointer;

  span {
    transform: translateX(-100%);
    display: block;
  }
`;

export const title: ThemedFunctor = ({
  theme,
}) => css`
  ${getTypography(theme, TypographyName.H4)}
`;

export const content: ThemedFunctor = ({
  theme,
}) => css`
  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    display: flex;
  }
`;

export const preview: ThemedFunctor = ({
  theme,
}) => css`
  margin-top: ${theme.spaceUnits.mobile.SMALL};

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    width: 17rem;
    flex-shrink: 0;
    margin-top: 0;
  };
`;

export const cover = css`
  position: relative;
`;

export const gallery: ThemedFunctor = ({ theme }) => css`
  ${getSpacing.marginTop(theme, SpacingName.SMALLER)}
  display: none;

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    display: block;
  };
`;

export const badges = css`
  position: absolute;
  top: .5rem;
  left: .5rem;
  right: 0;
  z-index: 2;
  display: flex;
  gap: .5rem;
  flex-wrap: wrap;
`;

export const banner: ThemedFunctor = ({
  theme,
}) => css`
  ${getTypography(theme, TypographyName.H4)}
  text-align: center;
  background-color: ${rgba(theme.palettes.brand.primary, 0.8)};
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  padding: .5rem 1rem;
  transform: translateY(-50%);
  color: ${theme.palettes.neutrals.lightest};
  text-transform: uppercase;
  z-index: 2;
`;

export const info: ThemedFunctor = ({
  theme,
}) => css`
  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    order: 2;
    flex-grow: 1;
    padding-left: ${theme.spaceUnits.desktop.SMALL};
    padding-bottom: 3.5rem;
    position: relative;
  }
`;

export const suburb: ThemedFunctor = ({
  theme,
}) => css`
  ${getTypography(theme, TypographyName.SMALL)}
  margin-top: ${theme.spaceUnits.mobile.SMALLEST};
  max-width: 32rem;
`;

export const price: ThemedFunctor = ({
  theme,
}) => css`
  ${getTypography(theme, TypographyName.H4)}
  ${getSpacing.marginTop(theme, SpacingName.SMALLER)}
`;

export const description: ThemedFunctor = ({ theme }) => css`
  ${getTypography(theme, TypographyName.SMALL)}
  ${getSpacing.marginTop(theme, SpacingName.SMALLER)}
  display: none;
  max-width: 32rem;

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    display: block;
  }
`;

export const actions: ThemedFunctor = ({
  theme,
}) => css`
  margin-top: ${theme.spaceUnits.desktop.SMALLER};
  position: absolute;
  bottom: 0;
  left: auto;
  z-index: 3;
  display: none;

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    display: block;
  }
`;

export const mobileActions: ThemedFunctor = ({
  theme,
}) => css`
  margin-top: ${theme.spaceUnits.mobile.SMALLER};
  position: relative;
  z-index: 3;

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    display: none;
  }
`;

export const highlights: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.marginTop(theme, SpacingName.SMALLER)};
`;
